<template>
    <div v-bind="$attrs" class="wrap-bar-chart" :style="'width:'+divwidth+';'">
        <apex-charts class="bar-chart" type="bar" :height="height" :width="width" :options="chartOptions" :series="series"></apex-charts>

        <slot name="content"></slot>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
import { colors } from '@/Composables/ChartColors';
import { formatIntegerPrice } from '@/Mixins/Formatting';

export default {
    props: {
        options: {
            type: Object,
            default: function () {
                return {};
            },
        },

        height: {
            type: String,
            default: '100%',
        },

        width: {
            type: String,
            default: '100%',
        },
        divwidth: {
            type: String,
        },
        title: {
            type: String,
            default: '',
        },

        alignTitleLeft: {
            type: Boolean,
            default: false,
        },

        subtitle: {
            type: String,
            default: '',
        },

        toolbar: {
            type: Boolean,
            default: false,
        },

        hideLegend: {
            type: Boolean,
            default: false,
        },

        showDataLabels: {
            type: Boolean,
            default: false,
        },

        distributed: {
            type: Boolean,
            default: false,
        },

        isPriceChart: {
            type: Boolean,
            default: false,
        },

        barHeight: {
            type: String,
            default: '70%',
        },

        labels: {
            type: Array,
            default: function () {
                return [];
            },
        },

        maxLabelWidth: {
            type: Number,
            default: 160,
        },

        annotations: {
            type: Array,
            default: function () {
                return [];
            },
        },

        series: {
            type: Array,
            required: true,
        },

        horizontal: {
            type: Boolean,
            default: false,
        },
        offsetX:{
            type: Number,
            default: 0
        },
        isFloat:{
            type: Boolean,
            default: false
        }
    },

    computed: {
        chartOptions() {
            return {
                noData: {
                    text: i18n.t('charts.noData'),
                    align: 'center',
                    verticalAlign: 'middle',
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '14px',
                        fontFamily: undefined,
                    },
                },
                chart: {
                    toolbar: {
                        show: this.toolbar,
                    },
                    width: "100%",
                    height: 320,
                    type: "bar",
                    maxHeight:320
                },

                annotations: {
                    xaxis: this.annotations,
                },

                dataLabels: {
                    enabled: this.showDataLabels,
                    offsetX: this.offsetX,
                    background: {
                        enabled: true,
                        opacity: 0.45,
                        foreColor: '#000',
                        dropShadow: {
                            enabled: true,
                            color: '#000',
                            opacity: 0.45,
                        },
                    },
                    formatter: (val) => {
                        return this.isPriceChart ? formatIntegerPrice(val) : val;
                    },
                },

                tooltip: {
                    y: {
                        title: {
                            // Hide the series name as we won't need it.
                            // formatter: (seriesName) => {
                            formatter: () => {
                                return '';
                            },
                        },
                        formatter: (val, { series, seriesIndex, dataPointIndex, w }) =>{
                            var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
                            return this.isPriceChart ? formatIntegerPrice(val) : val != data.y ? data.y : val;
                            //return this.isPriceChart ? formatIntegerPrice(val) : val != data.real_y ? data.real_y : val;
                        },
                    },
                },

                colors: colors,

                title: {
                    text: this.title,
                    align: this.alignTitleLeft ? 'left' : 'center',
                    style: {
                        fontSize: '16px',
                        fontWeight: 'bold',
                        fontFamily: 'Spartan',
                        color: '#006DB6',
                        //color: '#154579',
                    },
                },

                subtitle: {
                    text: this.subtitle,
                    style: {
                        fontSize: '12px',
                        fontWeight: 'book',
                        fontFamily: 'Spartan',
                        color: '#747B86',
                    },
                },

                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        barHeight: this.barHeight,
                        distributed: this.distributed,
                        horizontal: this.horizontal,
                        dataLabels: {
                            position: 'top'
                        }
                    },
                },

                legend: {
                    show: !this.hideLegend,
                },

                xaxis: {
                    categories: this.labels,
                },

                yaxis: {
                    labels: {
                        show: true,
                        trim: true,
                        //maxWidth: this.maxLabelWidth,
                        style: {
                            fontSize: '10px',
                            fontFamily: 'Spartan',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    },
                },
                responsive: [
                    {
                    breakpoint: 1000,
                    }
                ],

                ...this.options,
            };
        },
    },
};
</script>

<style></style>
